import React, { useEffect, useState } from 'react';

import type { LoginFormValues } from '@vlabs/monokit/entities/auth';
import { LoginForm } from '@vlabs/monokit/entities/auth';
import { clearFiltersStorage } from '@vlabs/monokit/shared/lib';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { fetchCurrentUser, login as auth } from '@vlabs/pages/auth/store';

import { useLoginPageTranslation } from './i18n';
import st from './LoginPage.module.sass';

interface LoginPageProps {
  CustomBrand?: React.ReactNode;
}

function LoginPage({
  CustomBrand = undefined,
}: LoginPageProps): React.JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useLoginPageTranslation();
  const [error, setError] = useState<string>();
  const [isAnimationOn, setIsAnimationOn] = useState(false);

  useEffect(() => {
    const animationTimer = setTimeout(() => setIsAnimationOn(false), 1000);
    return () => {
      clearTimeout(animationTimer);
    };
  }, [isAnimationOn]);

  const onSubmit: (values: LoginFormValues) => void = async ({ login, password }) => {
    setError(undefined);
    try {
      await auth({ email: login, password });
      // Чистим сохранённые фильтры до восстановления сессии нового аккаунта, чтобы они не протекали между пользователями
      clearFiltersStorage();
      dispatch(fetchCurrentUser);
      history.push('/');
    } catch (e) {
      if (e.response) {
        const { status } = e.response;
        if (status === 401) {
          setError(t('error.login_or_password_is_wrong') ?? undefined);
        } else if (status === 403) {
          setError(t('error.user_is_blocked'));
        }
      }
    }
  };

  return (
    <Page>
      <PageContent className={st.Root}>
        {!!CustomBrand && <div className={st.Brand}>{CustomBrand}</div>}
        <div className={classNames(st.Wrapper, { [st.Error]: error })}>
          <LoginForm
            error={error}
            onSubmit={onSubmit}
          />
        </div>
      </PageContent>
    </Page>
  );
}

export { LoginPage };
